module.exports = __webpack_public_path__ + "img/new-image-concern.b4088a3e.png";